// Centralisation du thème. Si le thème change, il sera facile de le modifier partout si les autres fichiers importent depuis ce fichier.

export default {
  primaryColor: 'rgb(255, 103, 76)',
};